function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  width: "100",
  height: "100",
  xmlns: "http://www.w3.org/2000/svg"
}, props), React.createElement("title", null, "icon-x"), React.createElement("g", {
  id: "icon-x-icon-x",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  id: "icon-x-Path-Copy",
  fill: "#000",
  fillRule: "nonzero",
  d: "M100 9.74311111L90.31243 0 50.2426693 40.1244444 9.68757 6.31593543e-15 0 9.74311111 40.5550993 49.8675556 0.672007168 90.2568889 10.3595772 100 50.2426693 59.6177778 90.1595395 100 99.8471095 90.2568889 59.9231281 49.8675556z"
}))));